import { render, staticRenderFns } from "./SavedQuoteSummary.vue?vue&type=template&id=5d3bdc39"
import script from "./SavedQuoteSummary.vue?vue&type=script&lang=js"
export * from "./SavedQuoteSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports